import React from "react";
import "./PublicationCard.css";
import { Fade } from "react-reveal";
import { translate } from "../../i18n";

export default function PublicationCard({ pub, theme }) {
  return (
    <Fade bottom duration={650} distance="18px">
      <article className="publication-card-div">
        <div className="publication-icon-wrap" aria-hidden="true">
          <span className="iconify publication-icon" data-icon={pub.icon} />
        </div>
        <div className="publication-content">
          <p className="publication-creation-date">{pub.date}</p>
          <h2 className="publication-name" style={{ color: theme.text }}>
            {pub.name}
          </h2>
          {Array.isArray(pub.description) ? (
            <ul className="publication-description publication-responsibilities">
              {pub.description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            <p className="publication-description">{pub.description}</p>
          )}
        </div>
        {pub.rating > 0 && pub.reviewUrl && (
          <div className="publication-review">
            <span
              className="publication-stars"
              aria-label={`${pub.rating} ${translate("stars")}`}
            >
              {"★".repeat(pub.rating)}
            </span>
            <a href={pub.reviewUrl} target="_blank" rel="noopener noreferrer">
              {translate("View Review")}
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                aria-hidden="true"
              >
                <path d="M14 3h7v7M21 3 10 14M10 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5" />
              </svg>
            </a>
          </div>
        )}
      </article>
    </Fade>
  );
}
